<template>
    <div class="probe-holder">
        <div class="probes">
            <div class="dot">
                <div class="probe">Influenza A/B</div>
            </div>

            <div class="dot2" v-on:click="setProbeType('covid19')">
                <div class="probe">COVID19</div>
            </div>

            <div class="dot">
                <div class="probe">RSV</div>
            </div> 
        </div>               
    </div>
</template>
<style scoped>
.probe-holder {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
}
.probes {
    display: flex;
    margin: auto;
}
.dot {
  height: 300px;
  width: 300px;
  background-color: var(--primary-color);
  border-radius: 50%;
  border: 1px solid var(--primary-color);
  color: var(--secondary-color);
  display: flex;
  text-align: center;
  vertical-align: center;
  justify-content: center;
  margin-right: 35px;
  cursor: not-allowed;
  opacity: 0.2;
}

.dot2 {
  height: 300px;
  width: 300px;
  background-color: var(--primary-color);
  border-radius: 50%;
  border: 1px solid var(--primary-color);
  color: var(--secondary-color);
  display: flex;
  text-align: center;
  vertical-align: center;
  justify-content: center;
  margin-right: 35px;
  margin-bottom: 50px;
  cursor: pointer;
}

.probe {
    margin: auto;
    font-size: 30pt;
    font-weight: 100;
}
</style>
<script>
export default ({
    props: [ 'online', 'deviceType' ],
    methods: {
        setProbeType(probeType) {
            switch(this.deviceType) {
                case "16":
                    var nexturl = "InsertWells";
                break;
                case "96":
                    var nexturl = "InsertWells96";
                break;
                default:
                    var nexturl = "InsertWells";
                break;
            }
            this.axios.get("/api/lid/open").then(() => {
                this.$router.push({
                    name: nexturl,
                    params: {
                        testType: probeType,
                    }
                })
            })
        }
    },
    data() {
        return {
            testtype: null,
        }
    },
})
</script>
